import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import Login from "./pages/login";
import DashboardLayout from "./components/Layouts/DashboardLayout";
import Dashboard from "./pages/dashboard";
import Vouchers from "./pages/vouchers";
import VoucherDetails from "./pages/vouchers/VoucherDetails";
import SubmitVouchers from "./pages/vouchers/SubmitVouchers";
import Request from "./pages/requests";
import MyAccount from "./pages/myaccount";
import HelpCenter from "./pages/helpCenter";
import AssignedToMe from "./pages/assignedToMe";
import RaiseARequest from "./pages/raiseARequest";
import RequestImprestAmount from "./pages/requestImprestAmount";
import CashDeposits from "./pages/cashDeposits";
import SubmitCashDeposit from "./pages/cashDeposits/SubmitCashDeposit";
import PettyCash from "./pages/pettyCash";
import PettyCashDetails from "./pages/pettyCash/PettyCashDetails";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "./components/Loader";
import { apiUrls } from "./utils/api/apiUrls";
import useApi from "./hooks/useApi";
import ThemeSelector from "./components/ThemeSelector";
import ImageViewer from "./pages/imageViewer";
import Landing from "./pages/landing";
import SapReport from "./pages/SAPReport/SapReport";
import VoucherReportDownload from "./pages/VoucherReportDownload/VoucherReportDownload";
import { getItem, removeItem } from "./utils/localStorage";
import ChangePassword from "./pages/login/changePassword";
import ForgetPassword from "./pages/login/forgetPassword";
import PdfViewer from "./pages/pdfViewer";

const App = () => {
  const router = () => (
    <div>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route exact path="/changepassword" element={<ChangePassword />} />
          <Route exact path="/forgetPassword" element={<ForgetPassword />} />
          <Route path="/" element={<Landing />} />
          <Route element={<DashboardLayout />}>
            {/* <Route path="/changepassword" element={<ChangePassword />} /> */}
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/petty-cash" element={<PettyCash />} />
            <Route path="/petty-cash/:vid" element={<PettyCashDetails />} />
            <Route path="/vouchers" element={<Vouchers />} />
            <Route path="/vouchers/sub-voucher" element={<Vouchers />} />
            <Route path="/cash-deposit" element={<CashDeposits />} />
            <Route
              path="/cash-deposit/submit"
              element={<SubmitCashDeposit />}
            />
            <Route path="/vouchers/:vid" element={<VoucherDetails />} />
            <Route path="/vouchers/submit" element={<SubmitVouchers />} />
            <Route path="/vouchers/edit" element={<SubmitVouchers />} />
            <Route path="/request" element={<Request />} />
            <Route path="/sap-reports" element={<SapReport />} />
            <Route
              path="/voucher-reports"
              element={<VoucherReportDownload />}
            />
            <Route path="/myaccount" element={<MyAccount />} />
            <Route path="/helpcenter" element={<HelpCenter />} />
            <Route path="/assignedtome" element={<AssignedToMe />} />
            <Route path="/raisearequest" element={<RaiseARequest />} />
            <Route path="/requestimprest" element={<RequestImprestAmount />} />
          </Route>
          <Route path="/view-image" element={<ImageViewer />} />
          <Route path="/view-pdf" element={<PdfViewer />} />
          <Route
            path="*"
            element={
              <div className="flex items-center justify-center h-[100vh]">
                <strong className="text-[4rem]">404 Not Found</strong>
              </div>
            }
          />
        </Routes>
      </Router>
    </div>
  );

  const ShowLoader = () => {
    const { loading } = useAuth();
    return <Loader loading={loading} />;
  };

  const RenderRoutes = () => {
    const { setUser, user } = useAuth();
    const { apiCall } = useApi();

    useEffect(() => {
      apiCall({
        url: apiUrls.user.profile,
        method: "get",
        onSuccess: (data = {}) => {
          setUser({ ...user, ...data });
        },
      });
    }, []);

    return router();
  };

  return (
    <ThemeSelector>
      <AuthProvider>
        <div className="bg-[var(--offWhite)] h-[100vh] font-family-regular">
          <ShowLoader />
          <RenderRoutes />
          <ToastContainer
            hideProgressBar
            closeOnClick
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            style={{ fontSize: 15 }}
            autoClose={2000}
          />
        </div>
      </AuthProvider>
    </ThemeSelector>
  );
};

export default App;
